// extracted by mini-css-extract-plugin
module.exports = {"nav":"nav_nav__18BSY","profilelink":"nav_profilelink__3TkcF"};